import axios from 'axios';
import PropTypes from 'prop-types';
import { useAuth } from '@acast-tech/auth-client';
import { useMutation } from '@tanstack/react-query';

const useApiMutation = ({
  getRequestUrl,
  method = 'POST',
  onSuccess = () => {},
  onError = () => {},
}) => {
  const { getToken } = useAuth();

  const mutation = useMutation(
    async ({ data, path, options } = {}) => {
      const token = await getToken();
      const axiosClient = axios.create({
        baseURL: '/api',
        headers: {
          'content-type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      // we need to use some data to get the request url
      // usually we pass the showId, networkId, or episodeId, or any parameter that is part of the url
      const requestUrl = getRequestUrl(path);

      // some hooks can change the method, most of the time to activate/deactivate something
      const reqOptions = {
        method: options?.method || method,
      };

      // we pass data for POST, PUT, PATCH
      if (data && method !== 'GET') {
        reqOptions.data = data;
      }

      const res = await axiosClient(requestUrl, reqOptions);
      return res.data;
    },
    {
      onSuccess,
      onError,
    }
  );

  return mutation;
};

useApiMutation.propTypes = {
  getRequestUrl: PropTypes.func.isRequired,
  method: PropTypes.oneOf(['GET', 'POST', 'PUT', 'PATCH', 'DELETE']),
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
};

export default useApiMutation;
